import classNames from "classnames";

import { useHomepageDatoProps } from "lib/store/homepage";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import HomePageSectionHeader from "components/homePageSectionHeader/homePageSectionHeader";
import { useMappedNewsletters } from "lib/hooks/useMappedNewsletters";
import dynamic from "next/dynamic";
const NewsletterSection = dynamic(
  () => import("components/newsletterHubV2/NewsletterSection"),
  {
    ssr: false,
  }
);

export const NewslettersContent = () => {
  const { track } = useMixpanelTracking();
  const data = useHomepageDatoProps();
  const { featuredNewsletter, newsletterList } = useMappedNewsletters();

  return (
    <div className="mx-auto w-full max-w-content-mobile px-5 md:max-w-content lg:max-w-container lg:px-0 mdDesktop:max-w-container mdDesktop:px-5">
      <HomePageSectionHeader
        className="mb-4"
        title={data.newsletterSubSectionHeading}
        buttonText={data.newsletterCtaText}
        buttonUrl={data.newsletterCtaUrl}
        buttonClassName="inline-flex items-center border-r-brand-neutral font-bold text-brand-neutral"
        onButtonClick={async () => {
          await track("Homepage link click", {
            "Click link": data.newsletterCtaUrl,
            "Click text": data.newsletterCtaText,
            Component: "Newsletters",
          });
        }}
      />
      <NewsletterSection
        columns={newsletterList.length > 5 ? 6 : 5}
        featured={featuredNewsletter}
        newsletters={newsletterList}
      />
    </div>
  );
};

export const Newsletters = ({ className }: { className?: string }) => {
  return (
    <div
      className={classNames(
        "flex h-auto flex-col items-center bg-gray-100",
        className
      )}
    >
      <NewslettersContent />
    </div>
  );
};
